import { useState } from "react";
import { Play } from "lucide-react";
import { ToolFinish } from "@/components/tools/ToolFinish";
import { resetTrack, track } from "@/lib/toolTrack";

const STEPS = [
  ["Mindfulness", "Place a hand on your heart. Gently say to yourself:", "This is a moment of suffering. This is hard."],
  ["Common humanity", "Remind yourself that you're not the only one:", "Suffering is part of being human. Other people feel this too. I'm not alone."],
  ["Kindness", "Now offer yourself some warmth:", "May I be kind to myself in this moment. May I give myself what I need."],
];

export const CompassionTool = ({ tool }) => {
  const [step, setStep] = useState(-1);
  const [note, setNote] = useState("");
  const begin = () => { resetTrack(tool.slug); setNote(""); setStep(0); track(tool.slug, "start"); };
  const next = () => { if (step + 1 >= STEPS.length + 1) { setStep(99); track(tool.slug, "finish"); } else setStep(step + 1); };
  if (step === 99) return <ToolFinish tool={tool} onAgain={begin} />;
  if (step < 0) return (
    <div className="text-center"><p className="text-mm-muted mb-5">Think of something that's hard right now. You'll take three gentle steps toward kindness.</p>
      <button onClick={begin} className="mm-btn !px-8 !py-3.5 text-lg" data-testid="tool-start"><Play size={18} />Start</button></div>
  );
  if (step === STEPS.length) return (
    <div className="mm-fade-up" data-testid="tool-compassion-note">
      <p className="text-lg font-semibold">What would you say to a friend feeling this way? Write it to yourself.</p>
      <textarea className="mm-input min-h-[110px] mt-3" maxLength={400} value={note} onChange={(e) => setNote(e.target.value)} placeholder="It makes sense that you feel this way. You're doing your best…" data-testid="tool-compassion-input" />
      <p className="text-xs text-mm-muted mt-1">Optional. Nothing is saved.</p>
      <button onClick={next} className="mm-btn mt-3" data-testid="tool-compassion-next">I'm done</button>
    </div>
  );
  const [title, lead, words] = STEPS[step];
  return (
    <div key={step} className="text-center max-w-lg mx-auto mm-fade-up" data-testid={`tool-compassion-step-${step}`}>
      <div className="flex justify-center gap-1.5 mb-5" aria-hidden>{STEPS.map(([name], k) => <span key={name} className={`h-1.5 w-10 rounded-full ${k <= step ? "bg-mm-primary" : "bg-mm-primary/20"}`} />)}</div>
      <div className="text-xs font-bold uppercase tracking-wider text-mm-primary">Step {step + 1} · {title}</div>
      <p className="text-mm-muted mt-3">{lead}</p>
      <p className="text-2xl font-semibold leading-snug mt-3" style={{ fontFamily: "Georgia, serif" }} aria-live="polite">“{words}”</p>
      <p className="text-sm text-mm-muted mt-4">Say it slowly, a few times, in a warm voice.</p>
      <button onClick={next} className="mm-btn mt-6" data-testid="tool-compassion-next">Next</button>
    </div>
  );
};
